/* SP Quick-add — vista rápida en cajón lateral (derecha) para productos con atributos.
   Se abre desde el botón de compra de la card (.sp-pcard__fab[data-sp-quick-add]).
   Contenido: galería de imágenes + marca/nombre/precio + selección de atributos + añadir al carrito.
   Datos vía /products/<handle>.js. Estilos de la tienda (clases sp-qa-*). */
(function () {
  if (window.__spQuickAddBound) return;
  window.__spQuickAddBound = true;

  var CUR = (window.Shopify && Shopify.currency && Shopify.currency.active) || 'EUR';
  function money(c) {
    try { return new Intl.NumberFormat(document.documentElement.lang || 'es-ES', { style: 'currency', currency: CUR }).format(c / 100); }
    catch (e) { return (c / 100).toFixed(2).replace('.', ',') + '€'; }
  }
  function esc(s) { return (s || '').replace(/"/g, '&quot;'); }

  // ---- Estructura del cajón (una vez) ----
  var root = document.createElement('div');
  root.className = 'sp-qa';
  root.innerHTML =
    '<div class="sp-qa__overlay" data-qa-close></div>' +
    '<aside class="sp-qa__drawer" role="dialog" aria-modal="true" aria-label="Vista rápida">' +
      '<button class="sp-qa__close" data-qa-close aria-label="Cerrar">&times;</button>' +
      '<div class="sp-qa__body"></div>' +
    '</aside>';
  document.body.appendChild(root);
  var bodyEl = root.querySelector('.sp-qa__body');

  function open() { root.classList.add('is-open'); document.documentElement.style.overflow = 'hidden'; }
  function close() { root.classList.remove('is-open'); document.documentElement.style.overflow = ''; }
  root.addEventListener('click', function (e) { if (e.target.closest('[data-qa-close]')) close(); });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') close(); });

  function optionValues(p, idx) {
    var seen = [], out = [];
    p.variants.forEach(function (v) {
      var val = v.options[idx];
      if (val != null && seen.indexOf(val) === -1) { seen.push(val); out.push(val); }
    });
    return out;
  }
  // ¿alguna variante disponible con este valor en la posición idx? (dado el resto de sel)
  function valueAvailable(p, idx, val, sel) {
    return p.variants.some(function (v) {
      if (v.options[idx] !== val) return false;
      for (var k = 0; k < p.options.length; k++) { if (k !== idx && sel[k] != null && v.options[k] !== sel[k]) return false; }
      return v.available;
    });
  }
  function firstImageForValue(p, idx, val) {
    var v = p.variants.find(function (x) { return x.options[idx] === val && x.featured_image; });
    return v ? v.featured_image.src : (p.featured_image || (p.images && p.images[0]));
  }
  function match(p, sel) {
    return p.variants.find(function (v) {
      for (var k = 0; k < p.options.length; k++) { if (sel[k] != null && v.options[k] !== sel[k]) return false; }
      return true;
    });
  }

  function render(p) {
    var sel = {};
    p.options.forEach(function (o, i) { sel[i] = (p.selected_or_first_available_variant || p.variants[0]).options[i]; });

    var isColor = p.options.map(function (o) { return /color/i.test(o.name || o); });
    var images = (p.images && p.images.length ? p.images : [p.featured_image]).filter(Boolean);

    function optionsHTML() {
      return p.options.map(function (o, i) {
        var name = o.name || o;
        var vals = optionValues(p, i);
        var head = '<div class="sp-qa__opt-label">' + name + ': <span data-qa-optval="' + i + '">' + (sel[i] || '') + '</span></div>';
        var items = vals.map(function (val) {
          var avail = valueAvailable(p, i, val, sel);
          var active = sel[i] === val ? ' is-active' : '';
          var un = avail ? '' : ' is-unavailable';
          if (isColor[i]) {
            var img = firstImageForValue(p, i, val);
            return '<button type="button" class="sp-qa__swatch' + active + un + '" data-qa-opt="' + i + '" data-qa-val="' + esc(val) + '" title="' + esc(val) + '" style="background-image:url(' + img + '&width=120)"></button>';
          }
          return '<button type="button" class="sp-qa__pill' + active + un + '" data-qa-opt="' + i + '" data-qa-val="' + esc(val) + '">' + val + '</button>';
        }).join('');
        return '<div class="sp-qa__opt">' + head + '<div class="sp-qa__opt-vals' + (isColor[i] ? ' sp-qa__opt-vals--sw' : '') + '">' + items + '</div></div>';
      }).join('');
    }

    var cur = match(p, sel) || p.variants[0];
    var onSale = cur.compare_at_price && cur.compare_at_price > cur.price;

    bodyEl.innerHTML =
      '<div class="sp-qa__media">' +
        '<div class="sp-qa__main"><img data-qa-main src="' + (images[0] ? images[0] : '') + '&width=800" alt="' + esc(p.title) + '"></div>' +
        (images.length > 1 ? '<div class="sp-qa__thumbs">' + images.slice(0, 6).map(function (im, ix) { return '<button type="button" class="sp-qa__thumb' + (ix === 0 ? ' is-active' : '') + '" data-qa-thumb="' + im + '&width=800"><img src="' + im + '&width=120" alt=""></button>'; }).join('') + '</div>' : '') +
      '</div>' +
      '<div class="sp-qa__info">' +
        (p.vendor ? '<div class="sp-qa__brand">' + p.vendor + '</div>' : '') +
        '<a class="sp-qa__title" href="' + p.url + '">' + p.title + '</a>' +
        '<div class="sp-qa__price"><span data-qa-price class="sp-qa__now">' + money(cur.price) + '</span>' +
          '<span data-qa-old class="sp-qa__old"' + (onSale ? '' : ' hidden') + '>' + (onSale ? money(cur.compare_at_price) : '') + '</span>' +
          '<span data-qa-badge class="sp-qa__badge"' + (onSale ? '' : ' hidden') + '>' + (onSale ? '-' + Math.round((cur.compare_at_price - cur.price) * 100 / cur.compare_at_price) + '%' : '') + '</span>' +
        '</div>' +
        '<div class="sp-qa__opts">' + optionsHTML() + '</div>' +
        '<div class="sp-qa__buy">' +
          '<div class="sp-qa__qty"><button type="button" data-qa-dec>&minus;</button><span data-qa-qtyval>1</span><button type="button" data-qa-inc>+</button></div>' +
          '<button type="button" class="sp-qa__atc" data-qa-atc>' +
            '<svg width="20" height="20" viewBox="0 0 24 24" fill="none" aria-hidden="true"><path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.8" d="M3 4h3l2.5 12h11L21 7H7"/><circle cx="10" cy="20" r="1.4" fill="currentColor"/><circle cx="18" cy="20" r="1.4" fill="currentColor"/></svg>' +
            '<span>Añadir al carrito</span></button>' +
        '</div>' +
        '<a class="sp-qa__full" href="' + p.url + '">Ver todos los detalles &rarr;</a>' +
      '</div>';

    var qty = 1;
    function setMain(src) { var m = bodyEl.querySelector('[data-qa-main]'); if (m) m.src = src; }
    function refresh() {
      var v = match(p, sel) || cur;
      var os = v.compare_at_price && v.compare_at_price > v.price;
      bodyEl.querySelector('[data-qa-price]').textContent = money(v.price);
      var oldEl = bodyEl.querySelector('[data-qa-old]'), bEl = bodyEl.querySelector('[data-qa-badge]');
      oldEl.hidden = !os; oldEl.textContent = os ? money(v.compare_at_price) : '';
      bEl.hidden = !os; bEl.textContent = os ? '-' + Math.round((v.compare_at_price - v.price) * 100 / v.compare_at_price) + '%' : '';
      if (v.featured_image) setMain(v.featured_image.src + '&width=800');
      var atc = bodyEl.querySelector('[data-qa-atc]');
      atc.disabled = !v.available; atc.querySelector('span').textContent = v.available ? 'Añadir al carrito' : 'Agotado';
      // reevaluar disponibilidad de valores + activos
      bodyEl.querySelectorAll('[data-qa-opt]').forEach(function (btn) {
        var i = +btn.getAttribute('data-qa-opt'), val = btn.getAttribute('data-qa-val');
        btn.classList.toggle('is-active', sel[i] === val);
        btn.classList.toggle('is-unavailable', !valueAvailable(p, i, val, sel));
      });
      p.options.forEach(function (o, i) { var s = bodyEl.querySelector('[data-qa-optval="' + i + '"]'); if (s) s.textContent = sel[i] || ''; });
    }

    bodyEl.addEventListener('click', function (e) {
      var opt = e.target.closest('[data-qa-opt]');
      if (opt) { sel[+opt.getAttribute('data-qa-opt')] = opt.getAttribute('data-qa-val'); refresh(); return; }
      var th = e.target.closest('[data-qa-thumb]');
      if (th) { setMain(th.getAttribute('data-qa-thumb')); bodyEl.querySelectorAll('.sp-qa__thumb').forEach(function (t) { t.classList.remove('is-active'); }); th.classList.add('is-active'); return; }
      if (e.target.closest('[data-qa-dec]')) { qty = Math.max(1, qty - 1); bodyEl.querySelector('[data-qa-qtyval]').textContent = qty; return; }
      if (e.target.closest('[data-qa-inc]')) { qty++; bodyEl.querySelector('[data-qa-qtyval]').textContent = qty; return; }
      if (e.target.closest('[data-qa-atc]')) {
        var v = match(p, sel); if (!v || !v.available) return;
        var btn = e.target.closest('[data-qa-atc]'); btn.disabled = true;
        var img = (v.featured_image && v.featured_image.src) || p.featured_image;
        // Como la ficha: anade, animacion al carrito y se abre el cajon (sin ir a /cart)
        spAddToCart(v.id, qty, btn, img, p.id)
          .then(function () { close(); })
          .catch(function (msg) { showError(btn, msg); })
          .then(function () { btn.disabled = false; });
        return;
      }
    });
    refresh();
  }


  /* ---- Anadir al carrito igual que la ficha (product-form de Horizon) ----
     Pide al anadir las secciones del cajon, lanza el CartAddEvent del tema (el cajon,
     con auto-open, se refresca y se abre; el contador se actualiza) y la animacion fly-to-cart. */
  function cartSectionIds() {
    var ids = [];
    document.querySelectorAll('cart-items-component').forEach(function (c) { if (c.dataset.sectionId && ids.indexOf(c.dataset.sectionId) < 0) ids.push(c.dataset.sectionId); });
    return ids;
  }
  function flyToCart(source, img) {
    var icon = document.querySelector('.header-actions__cart-icon');
    if (!icon || !source || !img) return;
    // <fly-to-cart> ya esta registrado en todas las paginas (fly-to-cart.js global). Sin import():
    // Shopify minifica este script clasico y convierte import() en require(), que no existe en el navegador.
    if (!customElements.get('fly-to-cart')) return;
    var f = document.createElement('fly-to-cart');
    f.classList.add('fly-to-cart--quick');
    f.style.setProperty('background-image', 'url(' + img + ')');
    f.style.setProperty('--start-opacity', '0');
    f.source = source; f.destination = icon;
    document.body.appendChild(f);
  }
  function spAddToCart(variantId, qty, source, img, productId) {
    var body = { items: [{ id: variantId, quantity: qty }] };
    var ids = cartSectionIds(); if (ids.length) body.sections = ids.join(',');
    return fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify(body) })
      .then(function (r) { return r.json().then(function (j) { if (!r.ok || j.status) throw (j.description || j.message || ''); return j; }); })
      .then(function (added) {
        flyToCart(source, img);
        return fetch('/cart.js').then(function (r) { return r.json(); }).catch(function () { return undefined; }).then(function (cart) {
          // Mismo evento que CartAddEvent de @theme/events ('cart:update' + detail); sin import() (ver flyToCart)
          {
            var ev = new Event('cart:update', { bubbles: true });
            ev.detail = { resource: cart, sourceId: String(variantId), data: {
              // cart-icon: si la fuente NO es la ficha, itemCount = TOTAL del carrito (la ficha suma). Sin carrito, sumamos como la ficha.
              source: cart ? 'sp-quick-add' : 'product-form-component',
              itemCount: cart ? cart.item_count : qty,
              productId: String(productId || ''), variantId: String(variantId), sections: added.sections
            } };
            document.dispatchEvent(ev);
          }
        });
      });
  }
  function showError(btn, msg) {
    var span = btn && btn.querySelector('span'); if (!span || !msg) return;
    var prev = span.textContent; span.textContent = msg;
    setTimeout(function () { span.textContent = prev; }, 3000);
  }

  // Compra directa desde la tarjeta (productos sin variantes): mismo comportamiento, sin ir a /cart
  document.addEventListener('submit', function (e) {
    var form = e.target.closest && e.target.closest('.sp-pcard__fabform');
    if (!form) return;
    e.preventDefault();
    var id = form.querySelector('input[name="id"]'); if (!id) return;
    var btn = form.querySelector('button'); if (btn) btn.disabled = true;
    var card = form.closest('.sp-pcard'); var im = card && card.querySelector('.sp-pcard__img');
    spAddToCart(+id.value, 1, btn, im && (im.currentSrc || im.src))
      .catch(function () {}).then(function () { if (btn) btn.disabled = false; });
  });

  document.addEventListener('click', function (e) {
    var t = e.target.closest('[data-sp-quick-add]');
    if (!t) return;
    e.preventDefault(); e.stopPropagation();
    var url = t.getAttribute('data-sp-quick-add');
    bodyEl.innerHTML = '<div class="sp-qa__loading">Cargando…</div>';
    open();
    fetch(url + '.js').then(function (r) { return r.json(); }).then(render).catch(function () { bodyEl.innerHTML = '<div class="sp-qa__loading">No se pudo cargar el producto.</div>'; });
  });
})();
